const frameOptions = [
  {
    id: 'Black Floating Frame 45w x 56h x 30rw for Canvas A81903',
    name: 'Black Floating Frame 45w x 56h x 30rw for Canvas A81903',
    thickness: 33,
    width: 45,
    height: 56,
    price: 25.95,
    img: '/assets/CanvasPrint&Frame/Black Floating Frame 45w x 56h x 30rw for Canvas A81903.jpg'
  },
  {
    id: 'White Floating Frame 45w x 56h x 30rw for Canvas A81904',
    name: 'White Floating Frame 45w x 56h x 30rw for Canvas A81904',
    thickness: 33,
    width: 45,
    height: 56,
    price: 25.95,
    img: '/assets/CanvasPrint&Frame/White Floating Frame 45w x 56h x 30rw for Canvas A81904.jpg'
  },
  {
    id: 'Natural Oak Floating Frame 35w x 55h x 25rw for Canvas Wood AR24',
    name: 'Natural Oak Floating Frame 35w x 55h x 25rw for Canvas Wood AR24',
    thickness: 25,
    width: 35,
    height: 55,
    price: 27,
    img: '/assets/CanvasPrint&Frame/Natural Oak Floating Frame 35w x 55h x 25rw for Canvas Wood AR24.jpg'
  },
  {
    id: 'Grey Floating Frame 30w x 50h x 20rw for Canvas Wood A101601',
    name: 'Grey Floating Frame 30w x 50h x 20rw for Canvas Wood A101601',
    thickness: 20,
    width: 30,
    height: 50,
    price: 24.95,
    img: '/assets/CanvasPrint&Frame/Grey Floating Frame 30w x 50h x 20rw for Canvas Wood A101601.jpg'
  },
  {
    id: 'Anthracite Floating Frame 30w x 50h x 20rw for Canvas Wood A1016',
    name: 'Anthracite Floating Frame 30w x 50h x 20rw for Canvas Wood A1016',
    thickness: 20,
    width: 30,
    height: 50,
    price: 24.95,
    img: '/assets/CanvasPrint&Frame/Anthracite Floating Frame 30w x 50h x 20rw for Canvas Wood A1016.jpg'
  },
  {
    id: 'Chocolate Floating Frame 30w x 50h x 20rw for Canvas Wood A10160',
    name: 'Chocolate Floating Frame 30w x 50h x 20rw for Canvas Wood A10160',
    thickness: 20,
    width: 30,
    height: 50,
    price: 24.95,
    img: '/assets/CanvasPrint&Frame/Chocolate Floating Frame 30w x 50h x 20rw for Canvas Wood A10160.jpg'
  },
  {
    id: 'Gold & Black Floating Frame 45w x 56h x 30rw for Canvas A81901',
    name: 'Gold & Black Floating Frame 45w x 56h x 30rw for Canvas A81901',
    thickness: 30,
    width: 45,
    height: 56,
    price: 25.95,
    img: '/assets/CanvasPrint&Frame/Gold & Black Floating Frame 45w x 56h x 30rw for Canvas A81901.jpg'
  },
  {
    id: 'Silver & Black Floating Frame 45w x 56h x 30rw for Canvas A81902',
    name: 'Silver & Black Floating Frame 45w x 56h x 30rw for Canvas A81902',
    thickness: 30,
    width: 45,
    height: 56,
    price: 25.95,
    img: '/assets/CanvasPrint&Frame/Silver & Black Floating Frame 45w x 56h x 30rw for Canvas A81902.jpg'
  },
  // {
  //   id: 'Black Box 20w x 40h x 35rh Popular A56101',
  //   name: 'Black Box 20w x 40h x 35rh Popular A56101',
  //   thickness: 35,
  //   width: 20,
  //   height: 40,
  //   price: 11.9,
  //   img: '/assets/CanvasPrint&Frame/Black Box 20w x 40h x 35rh Popular A56101.jpg'
  // },
  // {
  //   id: 'White Box 20w x 40h x 35rh Popular A56113',
  //   name: 'White Box 20w x 40h x 35rh Popular A56113',
  //   thickness: 35,
  //   width: 20,
  //   height: 40,
  //   price: 11.9,
  //   img: '/assets/CanvasPrint&Frame/White Box 20w x 40h x 35rh Popular A56113.jpg'
  // },
  // {
  //   id: 'Natural Oak Box 20wx40hx33rh Natural Wood Popular AR10OAK',
  //   name: 'Natural Oak Box 20wx40hx33rh Natural Wood Popular AR10OAK',
  //   thickness: 33,
  //   width: 20,
  //   height: 40,
  //   price: 15.3,
  //   img: '/assets/CanvasPrint&Frame/Natural Oak Box 20wx40hx33rh Natural Wood Popular AR10OAK.jpg'
  // },
  // {
  //   id: 'Black Flat 40w x 20h x 12rh Popular A52001',
  //   name: 'Black Flat 40w x 20h x 12rh Popular A52001',
  //   thickness: 12,
  //   width: 40,
  //   height: 20,
  //   price: 10.55,
  //   img: '/assets/CanvasPrint&Frame/Black Flat 40w x 20h x 12rh Popular A52001.jpg'
  // },
  // {
  //   id: 'White Flat 40w x 20h x 12rh Popular A52013',
  //   name: 'White Flat 40w x 20h x 12rh Popular A52013',
  //   thickness: 12,
  //   width: 40,
  //   height: 20,
  //   price: 10.55,
  //   img: '/assets/CanvasPrint&Frame/White Flat 40w x 20h x 12rh Popular A52013.jpg'
  // },
  // {
  //   id: 'Natural Oak Flat 40wx20hx14rh Natural Wood Popular AR27OAK',
  //   name: 'Natural Oak Flat 40wx20hx14rh Natural Wood Popular AR27OAK',
  //   thickness: 14,
  //   width: 40,
  //   height: 20,
  //   price: 15.85,
  //   img: '/assets/CanvasPrint&Frame/Natural Oak Flat 40wx20hx14rh Natural Wood Popular AR27OAK.jpg'
  // },
  // {
  //   id: 'Black Thin 20w x 20h x 15rh Popular A53601',
  //   name: 'Black Thin 20w x 20h x 15rh Popular A53601',
  //   thickness: 15,
  //   width: 20,
  //   height: 20,
  //   price: 6.15,
  //   img: '/assets/CanvasPrint&Frame/Black Thin 20w x 20h x 15rh Popular A53601.jpg'
  // },
  // {
  //   id: 'White Thin 20w x 20h x 15rh Popular A53613',
  //   name: 'White Thin 20w x 20h x 15rh Popular A53613',
  //   thickness: 15,
  //   width: 20,
  //   height: 20,
  //   price: 6.15,
  //   img: '/assets/CanvasPrint&Frame/White Thin 20w x 20h x 15rh Popular A53613.jpg'
  // },
  // {
  //   id: 'Natural Oak Thin 20wx20hx14rh Natural Wood Popular AR29OAK',
  //   name: 'Natural Oak Thin 20wx20hx14rh Natural Wood Popular AR29OAK',
  //   thickness: 14,
  //   width: 20,
  //   height: 20,
  //   price: 9.55,
  //   img: '/assets/CanvasPrint&Frame/Natural Oak Thin 20wx20hx14rh Natural Wood Popular AR29OAK.jpg'
  // },
  // {
  //   id: 'Black 30w x 20h x 15rh A53701',
  //   name: 'Black 30w x 20h x 15rh A53701',
  //   thickness: 15,
  //   width: 30,
  //   height: 20,
  //   price: 7.95,
  //   img: '/assets/CanvasPrint&Frame/Black 30w x 20h x 15rh A53701.jpg'
  // },
  // {
  //   id: 'Black Flat 60w x 20h x 14rh A56001',
  //   name: 'Black Flat 60w x 20h x 14rh A56001',
  //   thickness: 14,
  //   width: 60,
  //   height: 20,
  //   price: 16.8,
  //   img: '/assets/CanvasPrint&Frame/Black Flat 60w x 20h x 14rh A56001.jpg'
  // },
  // {
  //   id: 'Black Box 20w x 38h x 32rh A84701',
  //   name: 'Black Box 20w x 38h x 32rh A84701',
  //   thickness: 32,
  //   width: 20,
  //   height: 38,
  //   price: 12.3,
  //   img: '/assets/CanvasPrint&Frame/Black Box 20w x 38h x 32rh A84701.jpg'
  // },
  // {
  //   id: 'Black Box 41w x 35h x 26rh A68401',
  //   name: 'Black Box 41w x 35h x 26rh A68401',
  //   thickness: 26,
  //   width: 41,
  //   height: 35,
  //   price: 18.9,
  //   img: '/assets/CanvasPrint&Frame/Black Box 41w x 35h x 26rh A68401.jpg'
  // },
  // {
  //   id: 'Black 45w x 22h x 13rh A64403',
  //   name: 'Black 45w x 22h x 13rh A64403',
  //   thickness: 13,
  //   width: 45,
  //   height: 22,
  //   price: 13.75,
  //   img: '/assets/CanvasPrint&Frame/Black 45w x 22h x 13rh A64403.jpg'
  // },
  // {
  //   id: 'Black 30w x 22h x 13rh A64303',
  //   name: 'Black 30w x 22h x 13rh A64303',
  //   thickness: 13,
  //   width: 30,
  //   height: 22,
  //   price: 9.5,
  //   img: '/assets/CanvasPrint&Frame/Black 30w x 22h x 13rh A64303.jpg'
  // },
  // {
  //   id: 'Black Contemporary 74w x 23h x 16rh A89001',
  //   name: 'Black Contemporary 74w x 23h x 16rh A89001',
  //   thickness: 16,
  //   width: 74,
  //   height: 23,
  //   price: 16.4,
  //   img: '/assets/CanvasPrint&Frame/Black Contemporary 74w x 23h x 16rh A89001.jpg'
  // },
  // {
  //   id: 'Black Distressed 75w x 51h x 12rh A88001',
  //   name: 'Black Distressed 75w x 51h x 12rh A88001',
  //   thickness: 12,
  //   width: 75,
  //   height: 51,
  //   price: 31.5,
  //   img: '/assets/CanvasPrint&Frame/Black Distressed 75w x 51h x 12rh A88001.jpg'
  // },
  // {
  //   id: 'Black Embossed Ornate & Distressed 55w x 33h x 8rh A57703',
  //   name: 'Black Embossed Ornate & Distressed 55w x 33h x 8rh A57703',
  //   thickness: 8,
  //   width: 55,
  //   height: 33,
  //   price: 18.95,
  //   img: '/assets/CanvasPrint&Frame/Black Embossed Ornate & Distressed 55w x 33h x 8rh A57703.jpg'
  // },
  // {
  //   id: 'Black Embossed Ornate & Distressed 25w x 25h x 12rh A84403',
  //   name: 'Black Embossed Ornate & Distressed 25w x 25h x 12rh A84403',
  //   thickness: 12,
  //   width: 25,
  //   height: 25,
  //   price: 16.45,
  //   img: '/assets/CanvasPrint&Frame/Black Embossed Ornate & Distressed 25w x 25h x 12rh A84403.jpg'
  // },
  // {
  //   id: 'Black & Gold Curved 50w x 20h x 9rh A21403',
  //   name: 'Black & Gold Curved 50w x 20h x 9rh A21403',
  //   thickness: 9,
  //   width: 50,
  //   height: 20,
  //   price: 16.7,
  //   img: '/assets/CanvasPrint&Frame/Black & Gold Curved 50w x 20h x 9rh A21403.jpg'
  // },
  // {
  //   id: 'Black & Gold Curved 33w x 18h x 8rh A21303',
  //   name: 'Black & Gold Curved 33w x 18h x 8rh A21303',
  //   thickness: 8,
  //   width: 33,
  //   height: 18,
  //   price: 10.55,
  //   img: '/assets/CanvasPrint&Frame/Black & Gold Curved 33w x 18h x 8rh A21303.jpg'
  // },
  // {
  //   id: 'Black & Silver Curved 33w x 18h x 8rh A21304',
  //   name: 'Black & Silver Curved 33w x 18h x 8rh A21304',
  //   thickness: 8,
  //   width: 33,
  //   height: 18,
  //   price: 10.55,
  //   img: '/assets/CanvasPrint&Frame/Black & Silver Curved 33w x 18h x 8rh A21304.jpg'
  // },
  // {
  //   id: 'Black & Gold 37w x 23h x 14rh A69401',
  //   name: 'Black & Gold 37w x 23h x 14rh A69401',
  //   thickness: 14,
  //   width: 37,
  //   height: 23,
  //   price: 12.5,
  //   img: '/assets/CanvasPrint&Frame/Black & Gold 37w x 23h x 14rh A69401.jpg'
  // },
  // {
  //   id: 'Black & Gold 48w x 23h x 14rh A69501',
  //   name: 'Black & Gold 48w x 23h x 14rh A69501',
  //   thickness: 14,
  //   width: 48,
  //   height: 23,
  //   price: 16.95,
  //   img: '/assets/CanvasPrint&Frame/Black & Gold 48w x 23h x 14rh A69501.jpg'
  // },
  // {
  //   id: 'Black Contemporary 25w x 20h x 10rh A24204',
  //   name: 'Black Contemporary 25w x 20h x 10rh A24204',
  //   thickness: 10,
  //   width: 25,
  //   height: 20,
  //   price: 10.85,
  //   img: '/assets/CanvasPrint&Frame/Black Contemporary 25w x 20h x 10rh A24204.jpg'
  // },
  // {
  //   id: 'Black Gold 20w x 20h x 16rh Embossed Ornate AI99203',
  //   name: 'Black Gold 20w x 20h x 16rh Embossed Ornate AI99203',
  //   thickness: 16,
  //   width: 20,
  //   height: 20,
  //   price: 14.95,
  //   img: '/assets/CanvasPrint&Frame/Black Gold 20w x 20h x 16rh Embossed Ornate AI99203.jpg'
  // },
  // {
  //   id: 'White Flat 31w x 20h x 15rh A53713',
  //   name: 'White Flat 31w x 20h x 15rh A53713',
  //   thickness: 15,
  //   width: 31,
  //   height: 20,
  //   price: 7.95,
  //   img: '/assets/CanvasPrint&Frame/White Flat 31w x 20h x 15rh A53713.jpg'
  // },
  // {
  //   id: 'White Flat 60w x 20h x 14rh A56013',
  //   name: 'White Flat 60w x 20h x 14rh A56013',
  //   thickness: 14,
  //   width: 60,
  //   height: 20,
  //   price: 16.8,
  //   img: '/assets/CanvasPrint&Frame/White Flat 60w x 20h x 14rh A56013.jpg'
  // },
  // {
  //   id: 'White Box Wood Grain 16w x 29h x 22rh A84603',
  //   name: 'White Box Wood Grain 16w x 29h x 22rh A84603',
  //   thickness: 40,
  //   width: 16,
  //   height: 29,
  //   price: 10.05,
  //   img: '/assets/CanvasPrint&Frame/White Box Wood Grain 16w x 29h x 22rh A84603.jpg'
  // },
  // {
  //   id: 'White Box 20w x 38h x 32rh A84703',
  //   name: 'White Box 20w x 38h x 32rh A84703',
  //   thickness: 32,
  //   width: 20,
  //   height: 38,
  //   price: 12.3,
  //   img: '/assets/CanvasPrint&Frame/White Box 20w x 38h x 32rh A84703.jpg'
  // },
  // {
  //   id: 'White Box 41w x 35h x 26rh A68402',
  //   name: 'White Box 41w x 35h x 26rh A68402',
  //   thickness: 26,
  //   width: 41,
  //   height: 35,  
  //   price: 18.9,
  //   img: '/assets/CanvasPrint&Frame/White Box 41w x 35h x 26rh A68402.jpg'
  // },
  // {
  //   id: 'White 40w x 22h x 16rh A101203',
  //   name: 'White 40w x 22h x 16rh A101203',
  //   thickness: 16,
  //   width: 40,
  //   height: 22,
  //   price: 0.1,
  //   img: '/assets/CanvasPrint&Frame/White 40w x 22h x 16rh A101203.jpg'
  // },
  // {
  //   id: 'White 22w x 20h x 15rh A101503',
  //   name: 'White 22w x 20h x 15rh A101503',
  //   thickness: 15,
  //   width: 22,
  //   height: 20,
  //   price: 15.4,
  //   img: '/assets/CanvasPrint&Frame/White 22w x 20h x 15rh A101503.jpg'
  // },
  // {
  //   id: 'White Box 22w x 30h x 24rh A101303',
  //   name: 'White Box 22w x 30h x 24rh A101303',
  //   thickness: 24,
  //   width: 22,
  //   height: 30,
  //   price: 11.05,
  //   img: '/assets/CanvasPrint&Frame/White Box 22w x 30h x 24rh A101303.jpg'
  // },
  // {
  //   id: 'White 20w x 15h x 9rh AI90701',
  //   name: 'White 20w x 15h x 9rh AI90701',
  //   thickness: 9,
  //   width: 20,
  //   height: 15,
  //   price: 15.3,
  //   img: '/assets/CanvasPrint&Frame/White 20w x 15h x 9rh AI90701.jpg'
  // },
  // {
  //   id: 'White Embossed & Ornate 75w x 40h x 11rh A84504',
  //   name: 'White Embossed & Ornate 75w x 40h x 11rh A84504',
  //   thickness: 11,
  //   width: 75,
  //   height: 40,
  //   price: 0.1,
  //   img: '/assets/CanvasPrint&Frame/White Embossed & Ornate 75w x 40h x 11rh A84504.jpg'
  // },
  // {
  //   id: 'White & Gold 25w x 27h x 10rh AI97004',
  //   name: 'White & Gold 25w x 27h x 10rh AI97004',
  //   thickness: 10,
  //   width: 25,
  //   height: 27,
  //   price: 36.3,
  //   img: '/assets/CanvasPrint&Frame/White & Gold 25w x 27h x 10rh AI97004.jpg'
  // },
  // {
  //   id: 'White Distressed 75w x 51h 12rh A88002',
  //   name: 'White Distressed 75w x 51h 12rh A88002',
  //   thickness: 12,
  //   width: 75,
  //   height: 51,
  //   price: 31.75,
  //   img: '/assets/CanvasPrint&Frame/White Distressed 75w x 51h 12rh A88002.jpg'
  // },
  // {
  //   id: 'White 60w x 20h x 11rh A202304',
  //   name: 'White 60w x 20h x 11rh A202304',
  //   thickness: 11,
  //   width: 60,
  //   height: 20,
  //   price: 16.95,
  //   img: '/assets/CanvasPrint&Frame/White 60w x 20h x 11rh A202304.jpg'
  // },
  // {
  //   id: 'White Contemporary 35w x 15h x 9rh AI97602',
  //   name: 'White Contemporary 35w x 15h x 9rh AI97602',
  //   thickness: 9,
  //   width: 35,
  //   height: 15,
  //   price: 16.95,
  //   img: '/assets/CanvasPrint&Frame/White Contemporary 35w x 15h x 9rh AI97602.jpg'
  // },
  // {
  //   id: 'White Contemporary 20w x 40h x 10rh AI99805',
  //   name: 'White Contemporary 20w x 40h x 10rh AI99805',
  //   thickness: 10,
  //   width: 20,
  //   height: 40,
  //   price: 16.95,
  //   img: '/assets/CanvasPrint&Frame/White Contemporary 20w x 40h x 10rh AI99805.jpg'
  // },
  // {
  //   id: 'White & Silver 20w x 20h x 15rh Ornate & Embossed AI99204',
  //   name: 'White & Silver 20w x 20h x 15rh Ornate & Embossed AI99204',
  //   thickness: 15,
  //   width: 20,
  //   height: 20,
  //   price: 14.95,
  //   img: '/assets/CanvasPrint&Frame/White & Silver 20w x 20h x 15rh Ornate & Embossed AI99204.jpg'
  // },
  // {
  //   id: 'Natural Wood 30w x 20h x 14rh AR28OAK',
  //   name: 'Natural Wood 30w x 20h x 14rh AR28OAK',
  //   thickness: 14,
  //   width: 30,
  //   height: 20,
  //   price: 10.9,
  //   img: '/assets/CanvasPrint&Frame/Natural Wood 30w x 20h x 14rh AR28OAK.jpg'
  // },
  // {
  //   id: 'Natural Wood 22w x 20h x 15rh A101502',
  //   name: 'Natural Wood 22w x 20h x 15rh A101502',
  //   thickness: 15,
  //   width: 22,
  //   height: 20,
  //   price: 9.5,
  //   img: '/assets/CanvasPrint&Frame/Natural Wood 22w x 20h x 15rh A101502.jpg'
  // },
  // {
  //   id: 'Natural Wood Box 20w x 30h x 24rh AR26OAK',
  //   name: 'Natural Wood Box 20w x 30h x 24rh AR26OAK',
  //   thickness: 24,
  //   width: 20,
  //   height: 30,
  //   price: 10.2,
  //   img: '/assets/CanvasPrint&Frame/Natural Wood Box 20w x 30h x 24rh AR26OAK.jpg'
  // },
  // {
  //   id: 'Natural Wood Box 22w 30h x 24rh x A101302',
  //   name: 'Natural Wood Box 22w 30h x 24rh x A101302',
  //   thickness: 24,
  //   width: 22,
  //   height: 30,
  //   price: 11.05,
  //   img: '/assets/CanvasPrint&Frame/Natural Wood Box 22w 30h x 24rh x A101302.jpg'
  // },
  // {
  //   id: 'Natural Wood Box 30w x 54h x 49rh AI98401',
  //   name: 'Natural Wood Box 30w x 54h x 49rh AI98401',
  //   thickness: 49,
  //   width: 30,
  //   height: 54,
  //   price: 27.95,
  //   img: '/assets/CanvasPrint&Frame/Natural Wood Box 30w x 54h x 49rh AI98401.jpg'
  // },
  // {
  //   id: 'Natural Wood Box 40w x 35h x 25rh AI98201',
  //   name: 'Natural Wood Box 40w x 35h x 25rh AI98201',
  //   thickness: 25,
  //   width: 40,
  //   height: 35,
  //   price: 27.95,
  //   img: '/assets/CanvasPrint&Frame/Natural Wood Box 40w x 35h x 25rh AI98201.jpg'
  // },
  // {
  //   id: 'Natural Wood Contemporary 20w x 40h x 9rh AI98601',
  //   name: 'Natural Wood Contemporary 20w x 40h x 9rh AI98601',
  //   thickness: 9,
  //   width: 20,
  //   height: 40,
  //   price: 22.25,
  //   img: '/assets/CanvasPrint&Frame/Natural Wood Contemporary 20w x 40h x 9rh AI98601.jpg'
  // },
  // {
  //   id: 'Gold 20w x 20h x 15rh AI93609',
  //   name: 'Gold 20w x 20h x 15rh AI93609',
  //   thickness: 15,
  //   width: 20,
  //   height: 20,
  //   price: 15.5,
  //   img: '/assets/CanvasPrint&Frame/Gold 20w x 20h x 15rh AI93609.jpg'
  // },
  // {
  //   id: 'Gold Contemporary 40w x 20h x 13rh AI92009',
  //   name: 'Gold Contemporary 40w x 20h x 13rh AI92009',
  //   thickness: 13,
  //   width: 40,
  //   height: 20,
  //   price: 15.95,
  //   img: '/assets/CanvasPrint&Frame/Gold Contemporary 40w x 20h x 13rh AI92009.jpg'
  // },
  // {
  //   id: 'Gold Box 20w x 30h x 24rh AI93409',
  //   name: 'Gold Box 20w x 30h x 24rh AI93409',
  //   thickness: 24,
  //   width: 20,
  //   height: 30,
  //   price: 17.95,
  //   img: '/assets/CanvasPrint&Frame/Gold Box 20w x 30h x 24rh AI93409.jpg'
  // },
  // {
  //   id: 'Gold Box 20w x 40h x 34rh AI96109',
  //   name: 'Gold Box 20w x 40h x 34rh AI96109',
  //   thickness: 34,
  //   width: 20,
  //   height: 40,
  //   price: 18.95,
  //   img: '/assets/CanvasPrint&Frame/Gold Box 20w x 40h x 34rh AI96109.jpg'
  // },
  // {
  //   id: 'Gold Contemporary 20w x 20h x 15rh AI99701',
  //   name: 'Gold Contemporary 20w x 20h x 15rh AI99701',
  //   thickness: 15,
  //   width: 20,
  //   height: 20,
  //   price: 13.1,
  //   img: '/assets/CanvasPrint&Frame/Gold Contemporary 20w x 20h x 15rh AI99701.jpg'
  // },
  // {
  //   id: 'Gold Distressed 59w x 35h x 10rh A88201',
  //   name: 'Gold Distressed 59w x 35h x 10rh A88201',
  //   thickness: 10,
  //   width: 59,
  //   height: 35,
  //   price: 26.45,
  //   img: '/assets/CanvasPrint&Frame/Gold Distressed 59w x 35h x 10rh A88201.jpg'
  // },
  // {
  //   id: 'Gold Ornate Distressed & Embossed 55w x 33h x 8rh A57701',
  //   name: 'Gold Ornate Distressed & Embossed 55w x 33h x 8rh A57701',
  //   thickness: 8,
  //   width: 55,
  //   height: 33,
  //   price: 18.95,
  //   img: '/assets/CanvasPrint&Frame/Gold Ornate Distressed & Embossed 55w x 33h x 8rh A57701.jpg'
  // },
  // {
  //   id: 'Gold Ornate & Embossed 20w x 21h x 16rh A68701',
  //   name: 'Gold Ornate & Embossed 20w x 21h x 16rh A68701',
  //   thickness: 16,
  //   width: 20,
  //   height: 21,
  //   price: 13.75,
  //   img: '/assets/CanvasPrint&Frame/Gold Ornate & Embossed 20w x 21h x 16rh A68701.jpg'
  // },
  // {
  //   id: 'Gold / White Traditional 42w x 21h x 7rh A85405',
  //   name: 'Gold / White Traditional 42w x 21h x 7rh A85405',
  //   thickness: 7,
  //   width: 42,
  //   height: 21,
  //   price: 15.85,
  //   img: '/assets/CanvasPrint&Frame/Gold White Traditional 42w x 21h x 7rh A85405.jpg'
  // },
  // {
  //   id: 'Gold Contemporary 41w x 25h x 10rh A72101',
  //   name: 'Gold Contemporary 41w x 25h x 10rh A72101',
  //   thickness: 10,
  //   width: 41,
  //   height: 25,
  //   price: 23.1,
  //   img: '/assets/CanvasPrint&Frame/Gold Contemporary 41w x 25h x 10rh A72101.jpg'
  // },
  // {
  //   id: 'Gold Distressed 24w x 24h x 9rh A88101',
  //   name: 'Gold Distressed 24w x 24h x 9rh A88101',
  //   thickness: 9,
  //   width: 24,
  //   height: 24,
  //   price: 14.8,
  //   img: '/assets/CanvasPrint&Frame/Gold Distressed 24w x 24h x 9rh A88101.jpg'
  // },
  // {
  //   id: 'Gold Traditional 24w x 21h x 6rh A85301',
  //   name: 'Gold Traditional 24w x 21h x 6rh A85301',
  //   thickness: 6,
  //   width: 24,
  //   height: 21,
  //   price: 13.55,
  //   img: '/assets/CanvasPrint&Frame/Gold Traditional 24w x 21h x 6rh A85301.jpg'
  // },
  // {
  //   id: 'Siena - Gold 26w x 23h x 8rh A70901',
  //   name: 'Siena - Gold 26w x 23h x 8rh A70901',
  //   thickness: 8,
  //   width: 26,
  //   height: 23,
  //   price: 14.95,
  //   img: '/assets/CanvasPrint&Frame/Siena - Gold 26w x 23h x 8rh A70901.jpg'
  // },
  // {
  //   id: 'Silver Contemporary 20w x 20h x 14rh A80101',
  //   name: 'Silver Contemporary 20w x 20h x 14rh A80101',
  //   thickness: 14,
  //   width: 20,
  //   height: 20,
  //   price: 6.95,
  //   img: '/assets/CanvasPrint&Frame/Silver Contemporary 20w x 20h x 14rh A80101.jpg'
  // },
  // {
  //   id: 'Silver Crosshatch 30w x 20h x 15rh AI93708',
  //   name: 'Silver Crosshatch 30w x 20h x 15rh AI93708',
  //   thickness: 15,
  //   width: 30,
  //   height: 20,
  //   price:13.2,
  //   img: '/assets/CanvasPrint&Frame/Silver Crosshatch 30w x 20h x 15rh AI93708.jpg'
  // },
  // {
  //   id: 'Silver Crosshatch Flat 40w x 20h x 13rh AI92008',
  //   name: 'Silver Crosshatch Flat 40w x 20h x 13rh AI92008',
  //   thickness: 13,
  //   width: 40,
  //   height: 20,
  //   price: 15.95,
  //   img: '/assets/CanvasPrint&Frame/Silver Crosshatch Flat 40w x 20h x 13rh AI92008.jpg'
  // },
  // {
  //   id: 'Silver Crosshatch 20w x 20h x 15rh AI93608',
  //   name: 'Silver Crosshatch 20w x 20h x 15rh AI93608',
  //   thickness: 15,
  //   width: 20,
  //   height: 20,
  //   price: 10.5,
  //   img: '/assets/CanvasPrint&Frame/Silver Crosshatch 20w x 20h x 15rh AI93608.jpg'
  // },
  // {
  //   id: 'Silver Contemporary 20w x 20h x 15rh AI93610',
  //   name: 'Silver Contemporary 20w x 20h x 15rh AI93610',
  //   thickness: 15,
  //   width: 20,
  //   height: 20,
  //   price: 10.5,
  //   img: '/assets/CanvasPrint&Frame/Silver Contemporary 20w x 20h x 15rh AI93610.jpg'
  // },
  // {
  //   id: 'Metallic Silver 20w x 20h x 15rh AI93614',
  //   name: 'Metallic Silver 20w x 20h x 15rh AI93614',
  //   thickness: 15,
  //   width: 20,
  //   height: 20,
  //   price: 12.7,
  //   img: '/assets/CanvasPrint&Frame/Metallic Silver 20w x 20h x 15rh AI93614.jpg'
  // },
  // {
  //   id: 'Silver Crosshatch Box 20w x 30h x 24rh AI93408',
  //   name: 'Silver Crosshatch Box 20w x 30h x 24rh AI93408',
  //   thickness: 24,
  //   width: 20,
  //   height: 30,
  //   price: 17.95,
  //   img: '/assets/CanvasPrint&Frame/Silver Crosshatch Box 20w x 30h x 24rh AI93408.jpg'
  // },
  // {
  //   id: 'Silver Crosshatch Box 20w x 40h x 34rh AI96108',
  //   name: 'Silver Crosshatch Box 20w x 40h x 34rh AI96108',
  //   thickness: 34,
  //   width: 20,
  //   height: 40,
  //   price: 18.95,
  //   img: '/assets/CanvasPrint&Frame/Silver Crosshatch Box 20w x 40h x 34rh AI96108.jpg'
  // },
  // {
  //   id: 'Metallic Silver Box 20w x 30h x 24rh AI93414',
  //   name: 'Metallic Silver Box 20w x 30h x 24rh AI93414',
  //   thickness: 24,
  //   width: 20,
  //   height: 30,
  //   price: 20.5,
  //   img: '/assets/CanvasPrint&Frame/Metallic Silver Box 20w x 30h x 24rh AI93414.jpg'
  // },
  // {
  //   id: 'Metallic Silver Box 20w x 40h x 34rh AI96114',
  //   name: 'Metallic Silver Box 20w x 40h x 34rh AI96114',
  //   thickness: 34,
  //   width: 20,
  //   height: 40,
  //   price: 22.5,
  //   img: '/assets/CanvasPrint&Frame/Metallic Silver Box 20w x 40h x 34rh AI96114.jpg'
  // },
  // {
  //   id: 'Silver Leaf 65w x 28h x 16rh A64502',
  //   name: 'Silver Leaf 65w x 28h x 16rh A64502',
  //   thickness: 16,
  //   width: 65,
  //   height: 28,
  //   price: 25.05,
  //   img: '/assets/CanvasPrint&Frame/Silver Leaf 65w x 28h x 16rh A64502.jpg'
  // },
  // {
  //   id: 'Silver Contemporary 60w x 28h x 10rh A71402',
  //   name: 'Silver Contemporary 60w x 28h x 10rh A71402',
  //   thickness: 10,
  //   width: 60,
  //   height: 28,
  //   price: 23.95,
  //   img: '/assets/CanvasPrint&Frame/Silver Contemporary 60w x 28h x 10rh A71402.jpg'
  // },
  // {
  //   id: 'Silver Distressed & Traditional 59w x 35h x 10rh A88202',
  //   name: 'Silver Distressed & Traditional 59w x 35h x 10rh A88202',
  //   thickness: 10,
  //   width: 59,
  //   height: 35,
  //   price: 26.45,
  //   img: '/assets/CanvasPrint&Frame/Silver Distressed & Traditional 59w x 35h x 10rh A88202.jpg'
  // },
  // {
  //   id: 'Silver Distressed & Traditional 34w x 24h x 9rh A88102',
  //   name: 'Silver Distressed & Traditional 34w x 24h x 9rh A88102',
  //   thickness: 9,
  //   width: 34,
  //   height: 24,
  //   price: 14.8,
  //   img: '/assets/CanvasPrint&Frame/Silver Distressed & Traditional 34w x 24h x 9rh A88102.jpg'
  // },
  // {
  //   id: 'Silver Contemporary 41w x 25h x 10rh A72102',
  //   name: 'Silver Contemporary 41w x 25h x 10rh A72102',
  //   thickness: 10,
  //   width: 41,
  //   height: 25,
  //   price: 23.1,
  //   img: '/assets/CanvasPrint&Frame/Silver Contemporary 41w x 25h x 10rh A72102.jpg'
  // },
  // {
  //   id: 'Silver Traditional 28w x 21h x 11rh A83002',
  //   name: 'Silver Traditional 28w x 21h x 11rh A83002',
  //   thickness: 11,
  //   width: 28,
  //   height: 21,
  //   price: 13.75,
  //   img: '/assets/CanvasPrint&Frame/Silver Traditional 28w x 21h x 11rh A83002.jpg'
  // },
  // {
  //   id: 'Silver Traditional 24w x 21h x 6rh A85302',
  //   name: 'Silver Traditional 24w x 21h x 6rh A85302',
  //   thickness: 6,
  //   width: 24,
  //   height: 21,
  //   price: 13.55,
  //   img: '/assets/CanvasPrint&Frame/Silver Traditional 24w x 21h x 6rh A85302.jpg'
  // },
  // {
  //   id: 'Silver Contemporary 23w x 34h x 22rh A83402',
  //   name: 'Silver Contemporary 23w x 34h x 22rh A83402',
  //   thickness: 22,
  //   width: 23,
  //   height: 34,
  //   price: 13.75,
  //   img: '/assets/CanvasPrint&Frame/Silver Contemporary 23w x 34h x 22rh A83402.jpg'
  // },
  // {
  //   id: 'Silver Ornate Distressed & Embossed 55w x 33h x 8rh A57702',
  //   name: 'Silver Ornate Distressed & Embossed 55w x 33h x 8rh A57702',
  //   thickness: 8,
  //   width: 55,
  //   height: 33,
  //   price: 18.95,
  //   img: '/assets/CanvasPrint&Frame/Silver Ornate Distressed & Embossed 55w x 33h x 8rh A57702.jpg'
  // },
  // {
  //   id: 'Silver Ornate 25w x 20h x 10rh A201902',
  //   name: 'Silver Ornate 25w x 20h x 10rh A201902',
  //   thickness: 10,
  //   width: 25,
  //   height: 20,
  //   price: 9.95,
  //   img: '/assets/CanvasPrint&Frame/Silver Ornate 25w x 20h x 10rh A201902.jpg'
  // },
  // {
  //   id: 'Stain Teak Flat 30w x 20h x 15rh AI93702',
  //   name: 'Stain Teak Flat 30w x 20h x 15rh AI93702',
  //   thickness: 40,
  //   width: 30,
  //   height: 20,
  //   price: 10.95,
  //   img: '/assets/CanvasPrint&Frame/Stain Teak Flat 30w x 20h x 15rh AI93702.jpg'
  // },
  // {
  //   id: 'Stain Teak 20w x 20h x 15rh AI93602',
  //   name: 'Stain Teak 20w x 20h x 15rh AI93602',
  //   thickness: 15,
  //   width: 20,
  //   height: 20,
  //   price: 8.7,
  //   img: '/assets/CanvasPrint&Frame/Stain Teak 20w x 20h x 15rh AI93602.jpg'
  // },
  // {
  //   id: 'Stain Taupe 22w x 20h x 15rh A101507',
  //   name: 'Stain Taupe 22w x 20h x 15rh A101507',
  //   thickness: 15,
  //   width: 22,
  //   height: 20,
  //   price: 9.5,
  //   img: '/assets/CanvasPrint&Frame/Stain Taupe 22w x 20h x 15rh A101507.jpg'
  // },
  // {
  //   id: 'Stain Anthracite 22w x 20h x 15rh A101505',
  //   name: 'Stain Anthracite 22w x 20h x 15rh A101505',
  //   thickness: 15,
  //   width: 22,
  //   height: 20,
  //   price: 9.5,
  //   img: '/assets/CanvasPrint&Frame/Stain Anthracite 22w x 20h x 15rh A101505.jpg'
  // },
  // {
  //   id: 'Stain Grey 22w x 20h x 15rh A101501',
  //   name: 'Stain Grey 22w x 20h x 15rh A101501',
  //   thickness: 15,
  //   width: 22,
  //   height: 20,
  //   price: 9.5,
  //   img: '/assets/CanvasPrint&Frame/Stain Grey 22w x 20h x 15rh A101501.jpg'
  // },
  // {
  //   id: 'Stain Grey Box 22w x 30h x 24rh A101301',
  //   name: 'Stain Grey Box 22w x 30h x 24rh A101301',
  //   thickness: 24,
  //   width: 22,
  //   height: 30,  
  //   price: 11.05,
  //   img: '/assets/CanvasPrint&Frame/Stain Grey Box 22w x 30h x 24rh A101301.jpg'
  // },
  // {
  //   id: 'Stain Taupe Box 22w x 39h x 24rh A101307',
  //   name: 'Stain Taupe Box 22w x 39h x 24rh A101307',
  //   thickness: 24,
  //   width: 22,
  //   height: 39,
  //   price: 11.05,
  //   img: '/assets/CanvasPrint&Frame/Stain Taupe Box 22w x 39h x 24rh A101307.jpg'
  // },
  // {
  //   id: 'Stain Chocolate Box 22w x 30h x 24rh A101308',
  //   name: 'Stain Chocolate Box 22w x 30h x 24rh A101308',
  //   thickness: 24,
  //   width: 22,
  //   height: 30,
  //   price: 11.05,
  //   img: '/assets/CanvasPrint&Frame/Stain Chocolate Box 22w x 30h x 24rh A101308.jpg'
  // },
  // {
  //   id: 'Stain Teak Box 20w x 30h x 24rh AI93402',
  //   name: 'Stain Teak Box 20w x 30h x 24rh AI93402',
  //   thickness: 24,
  //   width: 20,
  //   height: 30,
  //   price: 13.95,
  //   img: '/assets/CanvasPrint&Frame/Stain Teak Box 20w x 30h x 24rh AI93402.jpg'
  // },
  // {
  //   id: 'Stain Teak Box 20w x 40h x 34rh AI96102',
  //   name: 'Stain Teak Box 20w x 40h x 34rh AI96102',
  //   thickness: 34,
  //   width: 20,
  //   height: 40,
  //   price: 16.25,
  //   img: '/assets/CanvasPrint&Frame/Stain Teak Box 20w x 40h x 34rh AI96102.jpg'
  // },
  // {
  //   id: 'Stain Anthracite 40w x 22h x 16rh A101205',
  //   name: 'Stain Anthracite 40w x 22h x 16rh A101205',
  //   thickness: 16,
  //   width: 40,
  //   height: 22,
  //   price: 15.4,
  //   img: '/assets/CanvasPrint&Frame/Stain Anthracite 40w x 22h x 16rh A101205.jpg'
  // },
  // {
  //   id: 'Stain Grey 40w x 22h x 16rh A101201',
  //   name: 'Stain Grey 40w x 22h x 16rh A101201',
  //   thickness: 16,
  //   width: 40,
  //   height: 22,
  //   price: 15.4,
  //   img: '/assets/CanvasPrint&Frame/Stain Grey 40w x 22h x 16rh A101201.jpg'
  // },
  // {
  //   id: 'Stain Taupe 40w x 22h x 16rh A101207',
  //   name: 'Stain Taupe 40w x 22h x 16rh A101207',
  //   thickness: 16,
  //   width: 40,
  //   height: 22,
  //   price: 15.4,
  //   img: '/assets/CanvasPrint&Frame/Stain Taupe 40w x 22h x 16rh A101207.jpg'
  // },
  // {
  //   id: 'Stain Chocolate 40w x 22h x 16rh A101208',
  //   name: 'Stain Chocolate 40w x 22h x 16rh A101208',
  //   thickness: 16,
  //   width: 40,
  //   height: 22,
  //   price: 15.4,
  //   img: '/assets/CanvasPrint&Frame/Stain Chocolate 40w x 22h x 16rh A101208.jpg'
  // },
  // {
  //   id: 'Stain Rustic Grey Flat 40w x 20h x 14rh AI90803',
  //   name: 'Stain Rustic Grey Flat 40w x 20h x 14rh AI90803',
  //   thickness: 14,
  //   width: 40,
  //   height: 20,
  //   price: 20.5,
  //   img: '/assets/CanvasPrint&Frame/Stain Rustic Grey Flat 40w x 20h x 14rh AI90803.jpg'
  // },
  // {
  //   id: 'Stain Walnut 56w x 20h x 9rh A23702',
  //   name: 'Stain Walnut 56w x 20h x 9rh A23702',
  //   thickness: 9,
  //   width: 56,
  //   height: 20,
  //   price: 16.3,
  //   img: '/assets/CanvasPrint&Frame/Stain Walnut 56w x 20h x 9rh A23702.jpg'
  // },
  // {
  //   id: 'Stain Walnut 42w x 20h x 10rh A23602',
  //   name: 'Stain Walnut 42w x 20h x 10rh A23602',
  //   thickness: 10,
  //   width: 42,
  //   height: 20,
  //   price: 13.05,
  //   img: '/assets/CanvasPrint&Frame/Stain Walnut 42w x 20h x 10rh A23602.jpg'
  // },
  // {
  //   id: 'Stain Walnut & Gold 50w x 20h x 9rh A21401',
  //   name: 'Stain Walnut & Gold 50w x 20h x 9rh A21401',
  //   thickness: 9,
  //   width: 50,
  //   height: 20,
  //   price: 16.7,
  //   img: '/assets/CanvasPrint&Frame/Stain Walnut & Gold 50w x 20h x 9rh A21401.jpg'
  // },
  // {
  //   id: 'Stain Walnut & Gold 33w x 18h x 8rh A21301',
  //   name: 'Stain Walnut & Gold 33w x 18h x 8rh A21301',
  //   thickness: 8,
  //   width: 33,
  //   height: 18,
  //   price: 10.55,
  //   img: '/assets/CanvasPrint&Frame/Stain Walnut & Gold 33w x 18h x 8rh A21301.jpg'
  // },
  // {
  //   id: 'Stain Honey & Burl / Gold 32w x 20h x 8rh A17801',
  //   name: 'Stain Honey & Burl / Gold 32w x 20h x 8rh A17801',
  //   thickness: 8,
  //   width: 32,
  //   height: 20,
  //   price: 12.7,
  //   img: '/assets/CanvasPrint&Frame/Stain Honey & Burl  Gold 32w x 20h x 8rh A17801.jpg'
  // },
  // {
  //   id: 'Stain Mahogany & Gold 31w x 20h x 10rh A55202',
  //   name: 'Stain Mahogany & Gold 31w x 20h x 10rh A55202',
  //   thickness: 10,
  //   width: 31,
  //   height: 20,
  //   price: 12.7,
  //   img: '/assets/CanvasPrint&Frame/Stain Mahogany & Gold 31w x 20h x 10rh A55202.jpg'
  // },
  // {
  //   id: 'Stain Mahogany & Gold 33w x 18h x 8rh A21302',
  //   name: 'Stain Mahogany & Gold 33w x 18h x 8rh A21302',
  //   thickness: 8,
  //   width: 33,
  //   height: 18,
  //   price: 10.55,
  //   img: '/assets/CanvasPrint&Frame/Stain Mahogany & Gold 33w x 18h x 8rh A21302.jpg'
  // },
  // {
  //   id: 'Stain Mahogany & Gold 19w x 19h x 12rh A56402',
  //   name: 'Stain Mahogany & Gold 19w x 19h x 12rh A56402',
  //   thickness: 12,
  //   width: 19,
  //   height: 19,
  //   price: 8.45,
  //   img: '/assets/CanvasPrint&Frame/Stain Mahogany & Gold 19w x 19h x 12rh A56402.jpg'
  // },
  // {
  //   id: 'Stain Walnut 19w x 19h x 12rh A56401',
  //   name: 'Stain Walnut 19w x 19h x 12rh A56401',
  //   thickness: 12,
  //   width: 19,
  //   height: 19,
  //   price: 8.45,
  //   img: '/assets/CanvasPrint&Frame/Stain Walnut 19w x 19h x 12rh A56401.jpg'
  // },
  // {
  //   id: 'Colour Kingfisher Blue 17w x 17h x 12rh AI91605',
  //   name: 'Colour Kingfisher Blue 17w x 17h x 12rh AI91605',
  //   thickness: 12,
  //   width: 17,
  //   height: 17,
  //   price: 9.9,
  //   img: '/assets/CanvasPrint&Frame/Colour Kingfisher Blue 17w x 17h x 12rh AI91605.jpg'
  // },
  // {
  //   id: 'Colour Powder Blue 17w x 17h x 12rh AI91606',
  //   name: 'Colour Powder Blue 17w x 17h x 12rh AI91606',
  //   thickness: 12,
  //   width: 17,
  //   height: 17,
  //   price: 9.9,
  //   img: '/assets/CanvasPrint&Frame/Colour Powder Blue 17w x 17h x 12rh AI91606.jpg'
  // },
  // {
  //   id: 'Colour Navy Blue 17w x 17h x 12rh AI91604',
  //   name: 'Colour Navy Blue 17w x 17h x 12rh AI91604',
  //   thickness: 12,
  //   width: 17,
  //   height: 17,
  //   price: 9.9,
  //   img: '/assets/CanvasPrint&Frame/Colour Navy Blue 17w x 17h x 12rh AI91604.jpg'
  // },
  // {
  //   id: 'Colour Violet 17w x 17h x 12rh AI91607',
  //   name: 'Colour Violet 17w x 17h x 12rh AI91607',
  //   thickness: 12,
  //   width: 17,
  //   height: 17,
  //   price: 9.9,
  //   img: '/assets/CanvasPrint&Frame/Colour Violet 17w x 17h x 12rh AI91607.jpg'
  // },
  // {
  //   id: 'Colour Fuschia Pink 17w x 17h x 12rh AI91608',
  //   name: 'Colour Fuschia Pink 17w x 17h x 12rh AI91608',
  //   thickness: 12,
  //   width: 17,
  //   height: 17,
  //   price: 9.9,
  //   img: '/assets/CanvasPrint&Frame/Colour Fuschia Pink 17w x 17h x 12rh AI91608.jpg'
  // },
  // {
  //   id: 'Colour Blush Pink 17w x 17h x 12rh AI91609',
  //   name: 'Colour Blush Pink 17w x 17h x 12rh AI91609',
  //   thickness: 12,
  //   width: 17,
  //   height: 17,
  //   price: 9.9,
  //   img: '/assets/CanvasPrint&Frame/Colour Blush Pink 17w x 17h x 12rh AI91609.jpg'
  // },
  // {
  //   id: 'Colour Powder Pink 17w x 17h x 12rh AI91610',
  //   name: 'Colour Powder Pink 17w x 17h x 12rh AI91610',
  //   thickness: 12,
  //   width: 17,
  //   height: 17,
  //   price: 9.9,
  //   img: '/assets/CanvasPrint&Frame/Colour Powder Pink 17w x 17h x 12rh AI91610.jpg'
  // },
  // {
  //   id: 'Colour Kiwi Green 17w x 17h x 12rh AI91603',
  //   name: 'Colour Kiwi Green 17w x 17h x 12rh AI91603',
  //   thickness: 12,
  //   width: 17,
  //   height: 17,
  //   price: 9.9,
  //   img: '/assets/CanvasPrint&Frame/Colour Kiwi Green 17w x 17h x 12rh AI91603.jpg'
  // },
  // {
  //   id: 'Colour Guacamole Green 17w x 17h x 12rh AI91602',
  //   name: 'Colour Guacamole Green 17w x 17h x 12rh AI91602',
  //   thickness: 12,
  //   width: 17,
  //   height: 17,
  //   price: 9.9,
  //   img: '/assets/CanvasPrint&Frame/Colour Guacamole Green 17w x 17h x 12rh AI91602.jpg'
  // },
  // {
  //   id: 'Colour Sunflower Yellow 17w x 17h x 12rh AI91613',
  //   name: 'Colour Sunflower Yellow 17w x 17h x 12rh AI91613',
  //   thickness: 12,
  //   width: 17,
  //   height: 17,
  //   price: 9.9,
  //   img: '/assets/CanvasPrint&Frame/Colour Sunflower Yellow 17w x 17h x 12rh AI91613.jpg'
  // },
  // {
  //   id: 'Colour Tangerine Orange 17w x 17h x 12rh AI91612',
  //   name: 'Colour Tangerine Orange 17w x 17h x 12rh AI91612',
  //   thickness: 12,
  //   width: 17,
  //   height: 17,
  //   price: 9.9,
  //   img: '/assets/CanvasPrint&Frame/Colour Tangerine Orange 17w x 17h x 12rh AI91612.jpg'
  // },
  // {
  //   id: 'Colour Poppy Red 17w x 17h x 12rh AI91611',
  //   name: 'Colour Poppy Red 17w x 17h x 12rh AI91611',
  //   thickness: 12,
  //   width: 17,
  //   height: 17,
  //   price: 9.9,
  //   img: '/assets/CanvasPrint&Frame/Colour Poppy Red 17w x 17h x 12rh AI91611.jpg'
  // },
  // {
  //   id: 'Colour Kingfisher Blue 30w x 20h x 13rh AI96205',
  //   name: 'Colour Kingfisher Blue 30w x 20h x 13rh AI96205',
  //   thickness: 13,
  //   width: 30,
  //   height: 20,
  //   price: 12.95,
  //   img: '/assets/CanvasPrint&Frame/Colour Kingfisher Blue 30w x 20h x 13rh AI96205.jpg'
  // },
  // {
  //   id: 'Colour Powder Blue 30w x 20h x 13rh AI96206',
  //   name: 'Colour Powder Blue 30w x 20h x 13rh AI96206',
  //   thickness: 13,
  //   width: 30,
  //   height: 20,
  //   price: 12.95,
  //   img: '/assets/CanvasPrint&Frame/Colour Powder Blue 30w x 20h x 13rh AI96206.jpg'
  // },
  // {
  //   id: 'Colour Navy Blue 30w x 20h x 13rh AI96204',
  //   name: 'Colour Navy Blue 30w x 20h x 13rh AI96204',
  //   thickness: 13,
  //   width: 30,
  //   height: 20,
  //   price: 12.95,
  //   img: '/assets/CanvasPrint&Frame/Colour Navy Blue 30w x 20h x 13rh AI96204.jpg'
  // },
  // {
  //   id: 'Colour Violet 30w x 20h x 13rh AI96207',
  //   name: 'Colour Violet 30w x 20h x 13rh AI96207',
  //   thickness: 13,
  //   width: 30,
  //   height: 20,
  //   price: 12.95,
  //   img: '/assets/CanvasPrint&Frame/Colour Violet 30w x 20h x 13rh AI96207.jpg'
  // },
  // {
  //   id: 'Colour Fuschia Pink 30w x 20h x 13rh AI96208',
  //   name: 'Colour Fuschia Pink 30w x 20h x 13rh AI96208',
  //   thickness: 13,
  //   width: 30,
  //   height: 20,
  //   price: 12.95,
  //   img: '/assets/CanvasPrint&Frame/Colour Fuschia Pink 30w x 20h x 13rh AI96208.jpg'
  // },
  // {
  //   id: 'Colour Powder Pink 30w x 20h x 13rh AI96210',
  //   name: 'Colour Powder Pink 30w x 20h x 13rh AI96210',
  //   thickness: 13,
  //   width: 30,
  //   height: 20,
  //   price: 12.95,
  //   img: '/assets/CanvasPrint&Frame/Colour Powder Pink 30w x 20h x 13rh AI96210.jpg'
  // },
  // {
  //   id: 'Colour Blush Pink 30w x 20h x 13rh AI96209',
  //   name: 'Colour Blush Pink 30w x 20h x 13rh AI96209',
  //   thickness: 13,
  //   width: 30,
  //   height: 20,
  //   price: 12.95,
  //   img: '/assets/CanvasPrint&Frame/Colour Blush Pink 30w x 20h x 13rh AI96209.jpg'
  // },
  // {
  //   id: 'Colour Kiwi Green 30w x 20h x 13rh AI96203',
  //   name: 'Colour Kiwi Green 30w x 20h x 13rh AI96203',
  //   thickness: 13,
  //   width: 30,
  //   height: 20,
  //   price: 12.5,
  //   img: '/assets/CanvasPrint&Frame/Colour Kiwi Green 30w x 20h x 13rh AI96203.jpg'
  // },
  // {
  //   id: 'Colour Guacamole Green 30w x 20h x 13rh AI96202',
  //   name: 'Colour Guacamole Green 30w x 20h x 13rh AI96202',
  //   thickness: 13,
  //   width: 30,
  //   height: 20,
  //   price: 12.5,
  //   img: '/assets/CanvasPrint&Frame/Colour Guacamole Green 30w x 20h x 13rh AI96202.jpg'
  // },
  // {
  //   id: 'Colour Sunflower Yellow 30w x 20h x 13rh AI96213',
  //   name: 'Colour Sunflower Yellow 30w x 20h x 13rh AI96213',
  //   thickness: 13,
  //   width: 30,
  //   height: 20,
  //   price: 12.5,
  //   img: '/assets/CanvasPrint&Frame/Colour Sunflower Yellow 30w x 20h x 13rh AI96213.jpg'
  // },
  // {
  //   id: 'Colour Tangerine Orange 30w x 20h x 13rh AI96212',
  //   name: 'Colour Tangerine Orange 30w x 20h x 13rh AI96212',
  //   thickness: 13,
  //   width: 30,
  //   height: 20,
  //   price: 12.95,
  //   img: '/assets/CanvasPrint&Frame/Colour Tangerine Orange 30w x 20h x 13rh AI96212.jpg'
  // },
  // {
  //   id: 'Colour Poppy Red 30w x 20h x 13rh AI96211',
  //   name: 'Colour Poppy Red 30w x 20h x 13rh AI96211',
  //   thickness: 13,
  //   width: 30,
  //   height: 20,
  //   price: 12.95,
  //   img: '/assets/CanvasPrint&Frame/Colour Poppy Red 30w x 20h x 13rh AI96211.jpg'
  // },
];

export default frameOptions;